/* MONTAGE · Von der Sternzeile zu den Bewertungen springen
   ═══════════════════════════════════════════════════════
   Die Sternzeile unter dem Produktnamen ist bei Dawn reine Anzeige. Auf
   Shops, die ihre Bewertungen weiter unten fuehren, erwarten Kunden dort
   aber einen Sprung dorthin, weil sie es von ueberall so kennen.

   Warum als Skript und nicht als Verweis im Kaufblock: der Kaufblock ist
   Dawns `main-product.liquid`. Jede Zeile darin ist ein Eingriff in
   fremden Code, der beim naechsten Dawn-Update zu pruefen waere. Ein
   Skript daneben kommt ohne das aus.

   Es ist eine Verbesserung, keine Voraussetzung: laeuft das Skript nicht,
   steht die Sternzeile da wie vorher und niemand merkt etwas. Genau
   deshalb wird die Zeile erst hier klickbar gemacht und nicht im Markup
   als Knopf angelegt, der ohne Skript nichts taete.

   Zugaenglich: die Zeile wird ein echter Verweis mit Ziel, also mit
   Tastatur erreichbar, mit Enter ausloesbar und im Kontextmenue
   kopierbar. Ein `div` mit Klickhandler koennte das alles nicht.
*/
(function () {
  'use strict';

  function bereit(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  bereit(function () {
    var ziel = document.querySelector('.mt-bewertungen');
    if (!ziel) return;

    /* Der Kaufblock, und nur er. Dokumentweit zu suchen waere hier
       derselbe Fehler wie bei der Sticky-Leiste: die Warenkorb-Schublade
       steht im Markup VOR dem Hauptinhalt, und ihre Produktkarten tragen
       dieselben Bewertungsklassen. */
    var kaufblock = document.querySelector('.product__info-container');
    if (!kaufblock) return;

    var zeile = kaufblock.querySelector('.rating, .product__rating');
    if (!zeile || zeile.closest('cart-drawer')) return;

    if (!ziel.id) ziel.id = 'bewertungen';

    var verweis = document.createElement('a');
    verweis.className = 'mt-sternsprung';
    verweis.href = '#' + ziel.id;

    /* Der Name des Verweises, und warum das hier so umstaendlich aussieht:
       Dawns Sternzeile traegt KEINEN Text, sie ist ein `role="img"` mit
       eigenem aria-label ("4,7 von 5,0 Sternen"). Ein aus textContent
       gebautes Label waere leer, und ein leeres aria-label auf dem Verweis
       ueberschreibt den Namen, den er sonst vom Bild darin erbt: der Link
       waere fuer Screenreader namenlos. Am Shop gesehen.

       Deshalb erst das Label des Bildes nehmen, dann den Text, und den
       Zusatz aus dem Markup holen statt ihn hier hinzuschreiben, damit er
       uebersetzbar bleibt. Bleibt am Ende nichts uebrig, wird gar kein
       Label gesetzt und der Verweis erbt wie gehabt. */
    var innen = zeile.getAttribute('aria-label') || (zeile.textContent || '').trim();
    var zusatz = (ziel.dataset && ziel.dataset.sprungtext) || '';
    var name = [innen, zusatz].filter(Boolean).join(', ');
    if (name) verweis.setAttribute('aria-label', name);

    zeile.parentNode.insertBefore(verweis, zeile);
    verweis.appendChild(zeile);

    verweis.addEventListener('click', function (e) {
      e.preventDefault();

      /* Weiches Scrollen nur auf kurzer Strecke.

         Am Shop gemessen: von der Sternzeile bis zu den Bewertungen liegen
         rund 27.600 px. Ueber diese Distanz kam `behavior: "smooth"` gar
         nicht an, die Seite blieb stehen, waehrend derselbe Aufruf mit
         "auto" sofort sprang. Der Grund ist die Seite selbst: das
         Bewertungs-Widget laedt nach und wird dabei ein paar tausend Pixel
         hoch, und ein laufendes weiches Scrollen bricht ab, wenn sich die
         Seitenhoehe unter ihm veraendert.

         Ueber so eine Strecke ist der Sprung ohnehin das bessere Verhalten:
         weiches Scrollen wuerde mehrere Sekunden dauern. */
      var abstand = Math.abs(ziel.getBoundingClientRect().top);
      var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var sanft = !ruhig && abstand < 3000;
      ziel.scrollIntoView({ behavior: sanft ? 'smooth' : 'auto', block: 'start' });
      /* Die Adresszeile mitnehmen, ohne den harten Sprung auszuloesen,
         damit der Zurueck-Knopf sich richtig verhaelt. */
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#' + ziel.id);
      }
    });
  });
})();
